import { Observable } from 'rxjs';
import { UseCase } from '../../base/use-case';
import { CategoryAcademyModel } from '../../models/academy/category-academy.model';
import { AcademyRepository } from '../../repositories/academy.repository';

export class GetCategoryAcademyAllUseCase
implements UseCase< void, CategoryAcademyModel > {

    constructor(
        private repository:
        AcademyRepository
    ) {}

    execute():Observable<CategoryAcademyModel> {
        return this.repository.getCategoryAcademyAll();
    }
}